import { css, html } from 'lit';
import { FlensSlide } from './slider-slide';

export class FlensProductLimoSlide extends FlensSlide {
	static properties = {
		productId: { type: Number, attribute: 'product-id' },
		categoryId: { type: Number, attribute: 'category-id' },
	};

	static styles = css`
    :host {
      display: flex;
      flex-wrap: wrap;
      gap: 2rem;
      scroll-snap-align: var(--scroll-snap-align, center);
    }

    .image,
    .content {
      inline-size: 100%;
    }

    .image {
      min-block-size: min-content;
      max-block-size: max-content;
    }

    .content {
      align-items: start;
      display: flex;
      flex-direction: column;
      justify-content: start;
      min-block-size: min-content;
    }

    :host(:not([active])) {
      opacity: 0.5;
    }

    .buttons {
      display: flex;
      flex-wrap: wrap;
      gap: var(--spacing-2);
      inline-size: 100%;
      justify-content: center;
      margin-block-start: 1.5rem;
    }

    ::slotted([slot="headline"]),
    ::slotted([slot="description"]) {
      inline-size: 100%;
      text-align: center;
    }

    @media screen and (width >= 576px) {
      .buttons {
        justify-content: start;
      }

      ::slotted([slot="headline"]),
      ::slotted([slot="description"]) {
        text-align: start;
      }
    }

    @media screen and (width >= 992px) {
      :host {
        flex-wrap: nowrap;
      }

      .image,
      .content {
        flex: 0 1 50%;
      }

      .content {
        justify-content: center;
      }

      .image {
        max-block-size: 100%;
      }
    }

    @media (prefers-reduced-motion: no-preference) {
      :host {
        transition: 0.3s all ease-out;
      }
    }
  `;

	constructor() {
		super();
		this.productId = -1;
		this.categoryId = -1;
	}

	render() {
		return html`
      <div class="image" part="image">
        <slot name="image"></slot>
      </div>
      <div class="content" part="content">
        <slot name="headline" class="headline"></slot>
        <slot name="description" class="description"></slot>
        <div class="buttons">
          <slot name="buttons"></slot>
        </div>
      </div>
    `;
	}
}

customElements.define('flens-product-limo-slide', FlensProductLimoSlide);
